import React, { FunctionComponent, useState } from 'react';
import { Box } from '@material-ui/core';
import { useAddScriptPackage } from '../../../../../gqlCommon/hooks/useAddScriptPackage';
import PACKAGE_LINKS from '../../../../../gqlCommon/constants/packageLinks';
import image360Styles from './image360Styles';
import { debounce } from 'throttle-debounce';

export interface IImage360Props {
  exteriorImagesUrls: string[];
}

const Image360: FunctionComponent<IImage360Props> = ({ exteriorImagesUrls }) => {
  const styles = image360Styles();
  useAddScriptPackage(PACKAGE_LINKS.IMAGES_SLIDER);
  const [windowWidth, setWindowWidth] = useState<number>(0);

  window.addEventListener(
    'resize',
    debounce(50, () => setWindowWidth(window.innerWidth)),
  );

  return (
    <Box className={styles.container}>
      <Box
        key={`${exteriorImagesUrls[0]}${windowWidth}`}
        className="cloudimage-360"
        data-image-list={JSON.stringify(exteriorImagesUrls)}
        data-amount="36"
        data-ratio="1"
        data-spin-reverse
        data-hide-360-logo
        data-disable-pointer-zoom
        data-disable-pinch-zoom
        data-test="image_display:360_exterior"
      />
    </Box>
  );
};

export default Image360;
